import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from '@mui/material';

const useInitMasonryColumns = () => {
  const [columns, setColumns] = useState(5);

  const breakpoints = useRef({
    mobile: 0,
    tablet: 768,
    laptop: 1024,
    desktop: 1440,
    desktop_large: 1920,
  });

  const columnsSize = useRef({
    mobile: 2,
    tablet: 3,
    laptop: 4,
    desktop: 5,
    desktop_large: 8,
  });

  const isMobile = useMediaQuery(`(max-width:${breakpoints.current.tablet}px)`);
  const isTablet = useMediaQuery(
    `(min-width:${breakpoints.current.tablet + 1}px) and (max-width:${breakpoints.current.laptop}px)`
  );
  const isLaptop = useMediaQuery(
    `(min-width:${breakpoints.current.laptop + 1}px) and (max-width:${breakpoints.current.desktop}px)`
  );
  const isDesktop = useMediaQuery(
    `(min-width:${breakpoints.current.desktop + 1}px) and (max-width:${breakpoints.current.desktop_large}px)`
  );
  const isDesktopLarge = useMediaQuery(`(min-width:${breakpoints.current.desktop + 1}px)`);

  useEffect(() => {
    if (isMobile) {
      setColumns(columnsSize.current.mobile);
      return;
    }
    if (isTablet) {
      setColumns(columnsSize.current.tablet);
      return;
    }
    if (isLaptop) {
      setColumns(columnsSize.current.tablet);
      return;
    }
    if (isDesktop) {
      setColumns(columnsSize.current.desktop);
      return;
    }
    if (isDesktopLarge) {
      setColumns(columnsSize.current.desktop_large);
      return;
    }
  }, [isMobile, isTablet, isLaptop, isDesktop, isDesktopLarge]);

  return {
    columns,
  };
};

export default useInitMasonryColumns;
